import { cn } from '../../lib/cn';

interface AvatarProps {
  initials: string;
  size?: number;
  hue?: number;
  className?: string;
  /**
   * Anneau « il s'est passé quelque chose » (le Fil) — le SEUL signal que
   * l'app s'autorise à l'ouverture : pas de chiffre, pas de couleur criarde,
   * lisible comme une story non vue. Un prospect qui voit l'écran n'apprend rien.
   */
  ring?: boolean;
}

export function Avatar({ initials, size = 40, hue, className, ring = false }: AvatarProps) {
  const h = hue ?? hashToHue(initials);
  return (
    <div
      className={cn('flex items-center justify-center shrink-0 font-bold', className)}
      style={{
        width: size,
        height: size,
        borderRadius: size,
        background: `hsl(${h}, 60%, 92%)`,
        color: `hsl(${h}, 55%, 32%)`,
        fontSize: size * 0.38,
        letterSpacing: '0.02em',
        boxShadow: ring ? '0 0 0 2px var(--color-surface), 0 0 0 4px var(--color-brand)' : undefined,
      }}
    >
      {initials.slice(0, 2).toUpperCase()}
    </div>
  );
}

function hashToHue(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (h * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % 360;
}

export function initialsFrom(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string {
  // Optional chaining sur la lecture d'index : `undefined[0]` throw alors que
  // `undefined?.[0] ?? ''` retourne ''. Protège tous les callers d'inputs
  // partiels (réponse API en cours de rollout, user en cache incomplet, etc.).
  return ((firstName?.[0] ?? '') + (lastName?.[0] ?? '')).toUpperCase();
}
